import { HttpContext } from '@angular/common/http';
import { inject, Injectable, Injector } from '@angular/core';
import { LOADER_TRANSPARENT } from '@appNeo/neoCore/interceptors/loaderInterceptor/loader.interceptor';
import { ImagenPrincipalPerfilComponent } from '@appNeo/neoShared/components/imagen-principal-perfil/imagen-principal-perfil.component';
import { TipoPaginadorEnum } from '@appNeo/neoShared/helpers/enums/TipoPaginador.enum';
import { IEstado } from '@appNeo/neoShared/helpers/interfaces/IEstado';
import { IRespApi } from '@appNeo/neoShared/helpers/interfaces/IResp-api';
import { Paginator } from '@appNeo/neoShared/models/paginator/paginator';
import { environment } from '@environments/environment';
import { BehaviorSubject, catchError, forkJoin, map, Observable, of, Subject, tap, throwError } from 'rxjs';
import { AuxiliarService } from '../auxiliar/auxiliar.service';
import { GLOBAL_CONFIG } from '@appNeo/core/global';
import { StorageService } from '@appNeo/neoCore/services/storage/storage.service';

export const FILTRO_ORDEN_DEFECTO = 'id';
type EntidadTipo<T> = {
    something: string;
    data: T;
}

@Injectable({
    providedIn: 'root'
})
export class UtilidadesCrudService {
    protected storageService = inject(StorageService);  
    public errorApi$: Subject<IRespApi> = new Subject<IRespApi>();
    public editandoEntidad$ = new BehaviorSubject<boolean>(false);
    public entidad$: BehaviorSubject<object> = new BehaviorSubject(null);
    public entidades$: BehaviorSubject<object[]> = new BehaviorSubject<object[]>([]);
    public totalEntidades$: BehaviorSubject<number> = new BehaviorSubject<number>(null);

    contextLoaderTransparent = { context: new HttpContext().set(LOADER_TRANSPARENT, true) };

    urlEntidad = environment.api_url;
    urlEntidades = environment.api_url;
    aliasAllControlador = '';
    aliasControlador = '';
    nombreEntidad = 'Entidad';
    nombreEntidadPlural = 'Entidades';
    filtrosOrdenPermitidosEntidad: string[] = [];
    camposSensibleTraduccion: string[] = ['nombre'];
    aliasParentAllControlador = '';
    aliasParentControlador = '';
    constructor(
        public http,
        public auxiliar,
        aliasAllControlador = undefined,
        aliasControlador = undefined,
        nombreEntidad = undefined,
        nombreEntidadPlural = undefined,
        filtrosOrdenPermitidosEntidad = ['id'],
        camposSensibleTraduccion = undefined,
        aliasParentAllControlador = undefined,
        aliasParentControlador = undefined
    ) {
        this.aliasControlador = aliasControlador;
        this.aliasAllControlador = aliasAllControlador;
        this.filtrosOrdenPermitidosEntidad = filtrosOrdenPermitidosEntidad;
        this.urlEntidad = (this.aliasControlador && this.aliasControlador !== '') ? this.urlEntidad + '/' + this.aliasControlador : this.urlEntidad;
        this.urlEntidades = (this.aliasAllControlador && this.aliasAllControlador !== '') ? this.urlEntidades + '/' + this.aliasAllControlador : this.urlEntidades;
        this.nombreEntidad = (nombreEntidad && nombreEntidad !== '') ? nombreEntidad : this.nombreEntidad;
        this.nombreEntidadPlural = (nombreEntidadPlural && nombreEntidadPlural !== '') ? nombreEntidadPlural : this.nombreEntidad;
        this.camposSensibleTraduccion = (camposSensibleTraduccion && camposSensibleTraduccion !== '') ? camposSensibleTraduccion : this.camposSensibleTraduccion;
        this.aliasParentControlador = aliasParentControlador;
        this.aliasParentAllControlador = aliasParentAllControlador;
        // console.log('[Establecemos service ]', this.urlEntidad, this.aliasControlador, this.nombreEntidad);
    }

    set editandoEntidad(flag: boolean) {
        this.editandoEntidad$.next(flag);
    }


    set entidad(entidad) {
        this.entidad$.next(entidad);
    }

    get identificadorEntidad(): string {
        return this.nombreEntidad.replace(/ /g, "");
    }
    desactivarEdicion() {
        this.editandoEntidad = false;       
    }
    getAll(paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any, loaderTransparente?: boolean, idParentControlador = undefined): Observable<object[] | any> {
        let paramContext = (loaderTransparente) ? { ...this.contextLoaderTransparent } : {};
        
        let request;
        if ( idParentControlador != undefined && this.aliasParentAllControlador != undefined) {
            request = `${environment.api_url}/${this.aliasParentAllControlador}/${idParentControlador}/${this.aliasAllControlador}?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(this.obtenerFiltros(filtros))}`;
        }else {
            request = (paginatorType === TipoPaginadorEnum.offline)
                ? this.urlEntidades
                : `${this.urlEntidades}?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(this.obtenerFiltros(filtros))}`;
        }
        return this.http.get(request, paramContext).pipe(
            tap((data: IRespApi) => { this.entidades$.next(this.mapearEntidades(data['data'])); }),
            tap((data: IRespApi) => { this.totalEntidades$.next(data.total); }),
            map((data: IRespApi) => this.mapearEntidades(data['data'])),
            catchError((err: IRespApi) => {
                return this.handleError(err, `IRequestGetAll${this.nombreEntidad}`);
            })
        );
    }



    getAllExcel(filtros?: any, loaderTransparente?: boolean, idParentControlador = undefined): Observable<string> {
        let paramContext = (loaderTransparente) ? { ...this.contextLoaderTransparent } : {};
        let request;
        if ( idParentControlador != undefined && this.aliasParentAllControlador != undefined) {
            request = `${environment.api_url}/${this.aliasParentAllControlador}/${idParentControlador}/${this.aliasAllControlador}/excel?${this.auxiliar.extraerFiltros(this.obtenerFiltros(filtros))}`;
        }else {
            request = `${this.urlEntidades}/excel?${this.auxiliar.extraerFiltros(this.obtenerFiltros(filtros))}`;
        }
        return this.http.get(request, paramContext).pipe(
            map((data: IRespApi) => data['data']),
            catchError((err: IRespApi) => {
                return this.handleError(err, `IRequestGetAllExcel${this.nombreEntidad}`);
            })
        );

    }

    obtenerFiltros(filtros?: any) {
        if (filtros) filtros.orden = (!filtros?.orden) ? FILTRO_ORDEN_DEFECTO : filtros.orden;

        // controlamos filtros no permitidos.
        if (filtros && filtros?.orden) {
            if (!this.filtrosOrdenPermitidosEntidad.includes(filtros.orden)) {
                filtros.orden = FILTRO_ORDEN_DEFECTO;
            }
        }
        return filtros;
    }

    mapearEntidades(entidades: any[]): any[] {
        return entidades.map(entidad => this.mapearEntidad(entidad));
    }

    mapearEntidad(entidad: any): any {
        GLOBAL_CONFIG.booleanKeysConvertibles.forEach(key => {
            if (key in entidad) {
                entidad[key] = this.auxiliar.getBoolean(entidad[key]);
            }
        });
    
        if (entidad.hasOwnProperty('idiomas')) {
            let camposTraduccionExtras = AuxiliarService.obtenerContenidoPorIdioma(entidad.idiomas);
            let valor = { valor: camposTraduccionExtras['nombre'] };
            entidad = { ...entidad, ...valor, ...camposTraduccionExtras };
        }
        let nombresCumpleanerosEdad = entidad?.cumpleaneros?.map(({nombre, edad}) => nombre + ` (${edad})`).join(', ');
        let nombresCumpleaneros = entidad?.cumpleaneros?.map(({nombre}) => nombre ).join(', ');
        entidad = { ...entidad, nombresCumpleanerosEdad: nombresCumpleanerosEdad , nombresCumpleaneros: nombresCumpleaneros};
        return entidad;
    }

    mapearEntidadAApi(entidad: any): any {
        let idiomas = AuxiliarService.conversionContenidoIdiomaDefecto(entidad, this.camposSensibleTraduccion);
        return {...entidad, idiomas}
    }


    entidadesRelacionadas(entidad: object) {
        let peticion = {};
        if (Object.keys(peticion).length > 0) {
            return forkJoin(peticion);
        } else {
            return of([]);
        }
    }

    get(id): Observable<any> {
        return this.http.get(`${this.urlEntidad}/${id}`).pipe(
            map((data: IRespApi) => this.mapearEntidad(data['data'])),
            catchError((err: IRespApi) => {
                return this.handleError(err, `IRequestGet${this.identificadorEntidad}`);
            })
        );
    }

    getEstados(): Observable<IEstado[]> {
        return this.http.get(`${this.urlEntidad}/estados`).pipe(
            map((data: IRespApi) => data['data']),
            catchError((err: IRespApi) => {
                console.log('Error ', err);
                return this.handleError(err, `IRequestGetEstados${this.identificadorEntidad}`);
            })
        );
    }

    create(request: any, idParentControlador = undefined): Observable<any> {
        console.log('CREATE ...');
        let _url = `${this.urlEntidad}`;
        if(idParentControlador) {
            _url = `${environment.api_url}/${this.aliasParentAllControlador}/${idParentControlador}/${this.aliasAllControlador}`;
        }
            
        let _request = this.mapearEntidadAApi(request);
        return this.http.post(_url, _request).pipe(
            map((resp: IRespApi) => {
                return resp.data;
            }),
            catchError((err: IRespApi) => {
                return this.handleError(err, `IRequestCreate${this.identificadorEntidad}`);
            })
        );
    }




    update(id: any, request?: any): Observable<any> {
        let _request = this.mapearEntidadAApi(request);
    
        return this.http.patch(`${this.urlEntidad}/${id}`, _request).pipe(
            map((data: any[]) => data['data']),
            catchError((err: IRespApi) => {
                return this.handleError(err, `IRequestUpdate${this.identificadorEntidad}`);
            })
        );
    }

    updatePut(id: any, request?: any, idParentControlador=undefined): Observable<any> {
        let _url = `${this.urlEntidad}`;
        if(idParentControlador) {
            _url = `${environment.api_url}/${this.aliasParentAllControlador}/${idParentControlador}/${this.aliasAllControlador}`;
        }
            

        let _request = this.mapearEntidadAApi(request);
        return this.http.put(`${_url}/${id}`, _request).pipe(
            map((data: any[]) => data['data']),
            catchError((err: IRespApi) => {
                return this.handleError(err, `IRequestUpdatePut${this.identificadorEntidad}`);
            })
        );
    }

    delete(id: any, idParentControlador = undefined): Observable<any> {
        let _url = `${this.urlEntidad}`;
        if(idParentControlador) {
            _url = `${environment.api_url}/${this.aliasParentAllControlador}/${idParentControlador}/${this.aliasAllControlador}`;
        }
            
        return this.http.delete(`${_url}/${id}`).pipe(
            catchError((err: IRespApi) => {
                return this.handleError(err, `IRequestDelete${this.identificadorEntidad}`);
            })
        );
    }

    activar(id: any): Observable<any> {
        let _url = `${this.urlEntidad}/${id}/activar`;
        return this.http.post(_url, {}).pipe(
            map((resp: IRespApi) => {
                return resp.data;
            }),
            catchError((err: IRespApi) => {
                return this.handleError(err, `IRequestActive${this.identificadorEntidad}`);
            })
        );
    }

    desactivar(id: any): Observable<any> {
        let _url = `${this.urlEntidad}/${id}/desactivar`;
        return this.http.post(_url, {}).pipe(
            map((resp: IRespApi) => {
                return resp.data;
            }),
            catchError((err: IRespApi) => {
                return this.handleError(err, `IRequestDesactive${this.identificadorEntidad}`);
            })
        );
    }
    

    /********************************/
    /* FICHEROS           */
    /********************************/
    /********************************/
    /* FICHEROS           */
    /********************************/

    postFicherosTemp(imagen: File, camposExtra?: object) {
        const formData: FormData = new FormData();
        formData.append('fichero[]', imagen, imagen.name);
        if (camposExtra && Object.keys(camposExtra)?.length > 0) {
        Object.entries(camposExtra).forEach(([key, value]) => {
            formData.append(key, value.toString());
        });
        }
         return this.http.post( `${this.urlEntidad}/ficherosTemp`, formData).pipe(
        catchError( (err: IRespApi) => {
            return this.handleError( err,  'IRequestPostImagenTempExtra');
        })
        );
    }

    postFicheros(id: string, request: any) {
        return this.http.post(`${this.urlEntidad}/${id}/ficheros`, request).pipe(
            map((resp: IRespApi) => resp.data),
            catchError((err: IRespApi) => {
                return this.handleError(err, `IRequestPost${this.identificadorEntidad}Fichero`);
            })
        );
    }

    // patchFicheros(id: string, idFichero: string, request: any) {
    //     return this.http.patch(`${this.urlEntidad}/${id}/ficheros/${idFichero}`, request).pipe(
    //         map((resp: IRespApi) => resp.data),
    //         catchError((err: IRespApi) => {
    //             return this.handleError(err, `IRequestEditar${this.identificadorEntidad}Fichero`);
    //         })
    //     );
    // }

    patchFicheros(id: string, idFichero: string, request: any) {
        return this.http.patch(`${this.urlEntidad}/${idFichero}/ficheros`, request).pipe(
            map((resp: IRespApi) => resp.data),
            catchError((err: IRespApi) => {
                return this.handleError(err, `IRequestEditar${this.identificadorEntidad}Fichero`);
            })
        );
    }

    deleteFicheros(id: string) {
        return this.http.delete(`${this.urlEntidad}/${id}/ficheros`).pipe(
            map((valor: string) => this.auxiliar.getBoolean(valor)),
            catchError((err: IRespApi) => {
                return this.handleError(err, `IRequestDelete${this.identificadorEntidad}Fichero`);
            })
        );
    }

    deleteFicherosPorId(id: string, idFichero: string) {
        return this.http.delete(`${this.urlEntidades}/${id}/ficheros/${idFichero}`).pipe(
            map((valor: string) => this.auxiliar.getBoolean(valor)),
            catchError((err: IRespApi) => {
                return this.handleError(err, `IRequestDelete${this.identificadorEntidad}Fichero`);
            })
        );
    }

    get configuracionCamposMultimedia() {
        let peticion = {
            tamanoMaximoFichero: this.getConfiguracionFicheros('ficheros_maxTamanoFichero'),
            formatosPermitidos: this.getConfiguracionFicheros('ficheros_formatos'),
        };
        return forkJoin(peticion);
    }

    getConfiguracionFicheros(clave: string) {
        return this.http.get(`${this.urlEntidad}/configuracionFicheros/${clave}`).pipe(
            map((data: IRespApi) => data['valor'])
        );
    }

    getConfiguracionFicherosGeneral() {
        return this.http.get(`${this.urlEntidad}/configuracionFicheros`).pipe(
            map((data: IRespApi) => data['data'])
        );
    }

    deleteImagenPrincipal(idExtra: string) {
        return this.http.delete(`${this.urlEntidad}imagenPrincipal/${idExtra}`).pipe(
            map((data: IRespApi) => data),
            catchError((err: IRespApi) => {
                return this.handleError(err, `IRequestDeleteImagenPrincipal${this.identificadorEntidad}`);
            })
        );
    }

    postImagenPrincipal(entidad, entidadService, imagenPrincipalProducto: ImagenPrincipalPerfilComponent) {
        entidadService.getImagenPrincipal(entidad.id).subscribe(imgPrincipal => {
            imagenPrincipalProducto.establecer(imgPrincipal);
        }
        )
    }

    deleteImagenDefecto(entidad, entidadService, imagenPrincipalProducto: ImagenPrincipalPerfilComponent) {
        console.log('Eliminar img principal ', entidad.id);
        entidadService.eliminarImagenPrincipal(entidad.id).subscribe(() => {
            this.postImagenPrincipal(entidad, entidadService, imagenPrincipalProducto);
        });
    }

    putImagenPrincipal(idExtra: string, request: any) {
        return this.http.put(`${this.urlEntidad}imagenPrincipal/${idExtra}`, request).pipe(
            map((data: IRespApi) => data),
            catchError((err: IRespApi) => {
                return this.handleError(err, `IRequesPutImagenPrincipal${this.identificadorEntidad}`);
            })
        );
    }

    getFicheros(id, paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any, loaderTransparente?: boolean) {
        let paramContext = (loaderTransparente) ? { ...this.contextLoaderTransparent } : {};

        let request = `${this.urlEntidades}/${id}/ficheros?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(this.obtenerFiltros(filtros))}`;
        return this.http.get(request, paramContext).pipe(
            map((data: IRespApi) => data['data']),
            catchError((err: IRespApi) => {
                return this.handleError(err, `IRequesGetFichero${this.identificadorEntidad}`);
            })
        );

    }

    /********************************/
    /* MANEJADOR ERRORES            */
    /********************************/
    

  public handleError(err: any, idRequest?: string): Observable<never> {
    // Casos especiales: errores no estándar enviados como string
    if (err === 'OK') {
        const mensaje = environment.errorServidorSinCodigo;
        return this.lanzarError(err, mensaje);
    }

    if (err === 'Unknown Error') {
        const mensaje = environment.errorServidorUnknown;
        return this.lanzarError(err, mensaje);
    }

    // Adjuntamos el idRequest como contexto
    err.request = idRequest;

    // Error validación (422)
    if (err.codigoError === 422) {
        console.warn('Error 422 recibido por CRUD:', err);
        this.errorApi$.next(err); // Emitimos error personalizado
    }

    // Mensaje base
    let mensaje = err?.mensaje || 'Error desconocido';

    // Error de permisos (403): agregamos detalles del array `data`
    if (err.codigoError === 403 && Array.isArray(err.data)) {
        const detalles = err.data.map(d => d.mensaje).join(', ');
        mensaje = `${mensaje}: ${detalles}`;
    }

    // Error no encontrado (404): manejamos string o array
    if (err.codigoError === 404 && err.data) {
        if (typeof err.data === 'string') {
        mensaje = `${mensaje}: ${err.data}`;
        } else if (Array.isArray(err.data)) {
        const detalles = err.data.map(d => d.mensaje).filter(Boolean).join(', ');
        if (detalles) mensaje = `${mensaje}: ${detalles}`;
        }
    }

    return this.lanzarError(err, mensaje);
    }

    private lanzarError(err: any, mensaje: string): Observable<never> {
    return throwError(() => ({
        error: true,
        data: err?.data,
        mensaje,
        err
    }));
    }

}
